if (!customElements.get('member-product-list')) {
    class MemberProductList extends HTMLElement {
        constructor() {
            super();
            this.items = this.querySelectorAll('.member_product_item');
            this.copiedLabel = this.getAttribute('data-copied-label');
            this.loading = false;
        }

        connectedCallback() {
            this.shopNow();
            this.copyButton();
        }

        copyButton() {
            this.items.forEach(item => {
                const copyButton = item.querySelector('.member_product_item__copy_btn');
                if (copyButton) {
                    copyButton.addEventListener('click', () => {
                        const originalContent = copyButton.innerHTML;
                        const codeToCopy = copyButton.getAttribute('data-code');

                        if (!codeToCopy || copyButton.classList.contains('copied')) return;

                        navigator.clipboard.writeText(codeToCopy).then(() => {
                            copyButton.classList.add('copied');
                            copyButton.innerHTML = this.copiedLabel;

                            setTimeout(() => {
                                copyButton.innerHTML = originalContent;
                                copyButton.classList.remove('copied');
                            }, 2000);
                        });
                    });
                }
            });
        }

        shopNow() {
            this.items.forEach(item => {
                const shopButton = item.querySelector('.member_product_item__shop-now');
                if (shopButton && !shopButton.classList.contains('loading')) {
                    shopButton.addEventListener('click', () => {
                        if (this.loading) return;

                        this.loading = true;
                        const checkoutButton = item.querySelector('.member_product_form .shopify-payment-button .shopify-payment-button__more-options');
                        if (checkoutButton) {
                            checkoutButton.click();
                        }
                        this.classList.add('loading');
                        shopButton.classList.add('loading');
                    });
                }
            });
        }
    }

    customElements.define('member-product-list', MemberProductList);
}
